import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs'
import { ApiService } from 'src/app/shared/services/apiService.service';
import { NgxSpinnerService } from "ngx-spinner";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { SeoService } from 'src/app/shared/seo/seo.service';
import { CanonicalService } from '../../shared/seo/canonical.service';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-customer-stories-list',
  templateUrl: './customer-stories-list.component.html',
  styleUrls: ['./customer-stories-list.component.scss']
})

export class CustomerStoriesListComponent implements OnInit {
  sub: Subscription = new Subscription
  safeUrl!: SafeResourceUrl;
  customerStoriesList: any =[];
  videoType: any;
  customerStories: any = [];
  count: number = 0;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = true;
  productLoaded:boolean = false;
  metatitle = "Customer stories - Tata Motors Online Sales";
  metadesc = "Customer stories - Tata Motors . Know more about Tata Motors vehicles";
  abc:boolean=false
  isDealerTab: string;
  videoUrl:SafeResourceUrl
  errormsg: any;
  environment1 = environment.s3bucket.url;
  showLoader: any = false;
  storyType:any;
  constructor(private apiService: ApiService, private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,public skeletonService: SkeletonService,
    private localStorage: secureStorage,
    private seoservice: SeoService,private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private canonicalservice: CanonicalService,) { }
    isForDealer: boolean=false ;
    isVideoTestimonialActive: boolean = true;
    isTestimonialActive: boolean = false;
    isDealerTestimonialActive: boolean = false;
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)){
      this.isDealerTab =localStorage.getItem("isDealerViewAll");
    }
    this.customerStories = [];
    let element = document.getElementById("pills-dealer-testimonials-tab");
    if(this.isDealerTab == "true"){
      element.className = 'nav-link active';
      this.getCustomerStories('DEALER',true);
      document.getElementById("pills-video-testimonial-tab").className = "nav-link";
      document.getElementById("pills-testimonials-tab").className = "nav-link";
    }
    else{
      this.getCustomerStories("VIDEO",false);
    }
    this.canonicalservice.createCanonicalURL('');
    this.seo();
    this.videoUrl = ''
    this.breadcrumb();

  }
  ngOnDestroy(){
    if (isPlatformBrowser(this.platformId)){
    localStorage.removeItem("isDealerViewAll");
    }

  }
  vedioModal(url: string, isForDealer) {
    this.videoUrl = ''
    if(isForDealer){
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }else{
           this.videoUrl = url;
    }
  }
  closeVideoModal() {
      this.videoUrl = '';

      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
      return this.sanitizer.bypassSecurityTrustHtml('')
  }

  getCustomerStories(type: String,isForDealer) {
    this.storyType = type;
    this.productLoaded = false
    this.customerStories = [];
    let data = {
      "action_type": type == 'DEALER' ? '' : type,
      "offset": 0,
      "size": 100,

    }
    if (isForDealer) {
      data["is_for"] = "dealer";
     this.isForDealer=true

    } else {
      data["action_type"] = type == 'DEALER' ? '' : type;
      this.isForDealer=false
      this.ngOnDestroy()
    }
    this.spinner.show()
    this.sub.add(this.apiService.getCustomerStories(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          let data =  response.data;
      // if(type == 'DEALER'){
      //    this.customerStories = data;
      //   }else{
          for (var k = 0; k < data?.length; k++) {
            this.videoType = "yt_url";
            let urls = data[k]["yt_url"];
            if (urls) {
              var vthaumbimage = this.youtube_parser(urls);
              let videos = "https://www.youtube.com/embed/" + vthaumbimage + "?autoplay=1&loop=0&controls=0&showinfo=0&rel=0&modestbranding=1";
              // "?autoplay=1&loop=0&mute=1&controls=0&showinfo=0&rel=0&modestbranding=1"
              this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videos);
            }
            else {
              this.safeUrl = "";
            }
            if (data[k]["image_url"] && this.safeUrl) {
              var a = this.formDataVideo(
                data[k]["ppl"],
                data[k]["description"],
                this.safeUrl,
                data[k]["image_url"],
                data[k]["model"],
                data[k]["name"]
              );
              this.customerStories.push(a);
            }

          }
        // }
        this.productLoaded = true
          this.spinner.hide()
        }
        else {
    this.customerStories = [];
          this.errormsg = response.data.msg
          if(this.errormsg == "Data not found."){
            this.isForDealer = true
          }
          this.productLoaded = true
          this.spinner.hide()
        }
      },
      error: () => {
    this.customerStories = [];
        this.productLoaded = true
        this.spinner.hide()
      },
      complete: () => { }
    }))
  }

  youtube_parser(url: any) {
    var regExp =
      /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    var match = url.match(regExp);
    return match && match[1]?.length == 11 ? match[1] : false;
  }
  formDataVideo(ppl: any, description: string, yt_url: any, image_url: string, model: any, name: any): videoBlogData {
    const userData: videoBlogData = {} as videoBlogData;

    userData.description = description;
    userData.yt_url = yt_url;
    userData.image_url = image_url;
    userData.ppl = ppl;
    userData.name = name;
    userData.model = model;
    return userData;
  }
  changeTestimonial(type: String,isForDealer: boolean) {
    this.customerStories = [];
    this.getCustomerStories(type, isForDealer);
  }
    breadcrumb() {
      if (isPlatformBrowser(this.platformId)){
    localStorage.removeItem('localBreadCrumb');
    this.breadcrumbdata = [];
    var breadcrumbList1 = {
      label: 'customer stories',
      url: `/customer-stories/`
    };
    this.breadcrumbdata.push(breadcrumbList1);
    if (isPlatformBrowser(this.platformId)) {
    this.localStorage.setItem('localBreadCrumb', JSON.stringify(this.breadcrumbdata));
    }
    this.showBreadCrumb = true;
  }
  }

  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }
}



export interface videoBlogData {

  description: string;
  yt_url: any;
  image_url: string;
  ppl: any;

  name: string;
  model: any;

}
